// src/components/GlobalLoader.jsx
import React from "react";

const GlobalLoader = () => {
	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
			<div className="flex flex-col items-center gap-5 rounded-2xl bg-white px-10 py-8 shadow-2xl">
				{/* Spinning Loader */}
				<div className="h-14 w-14 animate-spin rounded-full border-4 border-gray-300 border-t-blue-600"></div>

				{/* Optional Text */}
				<p className="text-lg font-medium text-gray-700">Loading...</p>
			</div>
		</div>
	);
};

export default GlobalLoader;